import { NgModule } from '@angular/core';
import { mapToCanActivate, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { netzbetreiberRoutes } from './netzbetreiber/netzbetreiber-routing.module';
import { AuthGuard } from './service/auth/auth.guard';
import { ProfileResolver } from './service/auth/profile.resolver';
import { UflaLandingpageComponent } from './ufla-landingpage/ufla-landingpage.component';
import { aufgabenRoutes } from './aufgabe/aufgaben-routing.module';
import { anleitungenRoutes } from './anleitungen/anleitungen-routing.module';
import { OAuth2AuthGuard } from './service/auth/oauth2.guard';

const routes: Routes = [
    {
        path: '',
        component: UflaLandingpageComponent,
        canActivate: mapToCanActivate([
            OAuth2AuthGuard,
        ]),
    },
    {
        path: 'dashboard',
        children: aufgabenRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: ProfileResolver,
        },
    },
    {
        path: 'netzbetreiber',
        children: netzbetreiberRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: ProfileResolver,
        },
    },
    {
        path: 'anleitungen',
        children: anleitungenRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: ProfileResolver,
        },
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                enableTracing: false,
                preloadingStrategy: PreloadAllModules,
                useHash: true,
                anchorScrolling: 'enabled',
            }),
    ],
    exports: [
        RouterModule,
    ],
    providers: [
        ProfileResolver,
    ],
})
export class AppRoutingModule {
}
